module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Miracles of Spiritual Healing")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch004#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch006#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#part-i-the-work-of-medium-jo%C3%A3o-and-the-entities"
    }
  }, [_vm._v("Part I: The Work of Medium João and the Entities")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#spiritual-healing-centre-casa-de-dom-in%C3%A1cio"
    }
  }, [_vm._v("Spiritual Healing Centre Casa de Dom Inácio")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#the-work-in-general"
    }
  }, [_vm._v("The Work in General")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#the-life-of-medium-jo%C3%A3o-before-the-establishment-of-casa"
    }
  }, [_vm._v("The Life of Medium João Before the Establishment of Casa")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#the-values-and-the-principles-guiding-the-work"
    }
  }, [_vm._v("The Values and the Principles Guiding the Work")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#the-policies-and-the-treatment-methods"
    }
  }, [_vm._v("The Policies and the Treatment Methods")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#the-healing-spirits-working-in-casa"
    }
  }, [_vm._v("The Healing Spirits Working in Casa")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#ignatius-loyola"
    }
  }, [_vm._v("Ignatius Loyola")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#francis-xavier"
    }
  }, [_vm._v("Francis Xavier")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#oswaldo-cruz"
    }
  }, [_vm._v("Oswaldo Cruz")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#other-entities"
    }
  }, [_vm._v("Other Entities")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#previous-research-results-from-casa"
    }
  }, [_vm._v("Previous Research Results from Casa")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#part-ii-research-results",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: “Research Results”")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#the-aim-and-objectives-of-the-research",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Aim and Objectives of the Research")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#implementation-of-the-research",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Implementation of the Research")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#the-target-group-of-the-research",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Target Group of the Research")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#research-methods-and-the-data-collection",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Research Methods and the Data Collection")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#analysing-the-data",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Analysing the Data")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#ethics-and-reliability",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ethics and Reliability")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#research-results",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Research Results")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#interest-in-spirituality-before-the-trip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interest in Spirituality Before the Trip")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#motives-for-the-trip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motives for the Trip")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#the-meaningful-experiences",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meaningful Experiences")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#being-in-casa-and-in-its-vicinity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Being in Casa and in Its Vicinity")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#visiting-medium-jo%C3%A3o-and-the-entities",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visiting Medium João and the Entities")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#the-physical-and-spiritual-surgeries",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Physical and Spiritual Surgeries")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#sitting-in-the-current-room",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sitting in the Current Room")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#crystal-bed-treatment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crystal Bed Treatment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#visiting-the-waterfall",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visiting the Waterfall")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#the-effects-and-benefits-of-the-trip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Effects and Benefits of the Trip")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#the-recoveries-and-the-changes-in-health",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Recoveries and the Changes in Health")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#mood-after-the-trip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mood After the Trip")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#spiritual-things-and-life-values",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiritual Things and Life Values")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#insights-ideas-and-impressions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Insights, Ideas and Impressions")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#other-changes-and-effects-on-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Changes and Effects on Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#trips-to-casa-and-the-future",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trips to Casa and the Future")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#discussion-and-conclusions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion and Conclusions")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#part-iii-personal-experiences-from-trips-to-casa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: Personal Experiences from Trips to Casa")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#section",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("* *")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-first-visit-confusion-faith-and-power",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Visit – Confusion, Faith and Power")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-healing-events-and-the-experiences-i-had-during-the-first-week",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Healing Events and the Experiences I Had During the First Week")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-activities-and-the-experiences-during-the-gap-days",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Activities and the Experiences During the Gap Days")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-healing-events-and-the-experiences-during-the-second-week",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Healing Events and the Experiences During the Second Week")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#observations-from-the-trip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Observations from the Trip")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-experiences-after-returning-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Experiences After Returning Home")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#second-visit-healing-and-communication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Visit – Healing and Communication")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-healing-events-and-experiences-during-the-first-week",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Healing Events and Experiences During the First Week")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-activities-and-experiences-during-the-gap-days",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Activities and Experiences During the Gap Days")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-healing-events-and-the-experiences-during-the-second-week-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Healing Events and the Experiences During the Second Week")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#experiences-after-returning-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Experiences After Returning Home")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#third-visit-invitation-to-become-a-daughter-of-casa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Third Visit – Invitation to Become a Daughter of Casa")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-healing-events-and-experiences-during-the-first-week-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Healing Events and Experiences During the First Week")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-activities-and-experiences-during-the-gap-days-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Activities and Experiences During the Gap Days")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#the-healing-events-during-the-second-week",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Healing Events During the Second Week")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#experiences-during-the-last-days",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Experiences During the Last Days")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#in-conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Conclusion")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#part-iv-theoretical-background-for-the-work-done-in-casa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV: Theoretical Background for the Work Done in Casa")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#concepts-and-phenomena",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concepts and Phenomena")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-universal-laws",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Universal Laws")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#spiritual-growth-as-the-meaning-of-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiritual Growth as the Meaning of Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#meditation-being-in-silence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meditation – Being in Silence")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-human-energy-system",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Human Energy System")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-energy-bodies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Energy Bodies")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-energy-centres-chakras",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Energy Centres – Chakras")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-causes-of-illnesses",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Causes of Illnesses")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#opening-blockages-in-chakras",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opening Blockages in Chakras")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#spiritual-healing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiritual Healing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#spiritualistic-philosophy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiritualistic Philosophy")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-main-principles-of-spiritualism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Main Principles of Spiritualism")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-fatherhood-of-god-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The fatherhood of God (1)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-brotherhood-of-man-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The brotherhood of man (2)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-communion-of-spirits-and-the-ministry-of-angels-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The communion of spirits and the ministry of angels (3)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-continuous-existence-of-the-human-soul-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The continuous existence of the human soul (4)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#personal-responsibility-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal responsibility (5)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#compensation-and-retribution-hereafter-for-all-the-good-and-the-evil-deeds-done-on-earth-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compensation and retribution hereafter for all the good and the evil deeds done on Earth (6)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#eternal-progress-is-open-to-every-human-soul-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eternal progress is open to every human soul (7)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#the-different-directions-of-spiritualism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Different Directions of Spiritualism")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#summary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#literature",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literature")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#electronic-publications",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Electronic publications")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#electronic-links",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Electronic links")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0